import apiBaseUrl from '../../utils/config'; // Adjust path as needed

class PatientContactPermissionService {
  constructor() {
    this.baseUrl = `${apiBaseUrl}/patient-permissions`;
  }

  // 🔐 Helper to include JWT token
  getAuthHeaders() {
    const token = localStorage.getItem('jwt');
    return {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    };
  }

  // ✅ Add new permission
  async add(permission) {
    const response = await fetch(`${this.baseUrl}/add`, {
      method: 'POST',
      headers: this.getAuthHeaders(),
      body: JSON.stringify(permission)
    });
    return response.json();
  }

  // ✅ Get all permissions
  async getAll() {
    const response = await fetch(`${this.baseUrl}/getall`, {
      headers: this.getAuthHeaders()
    });
    return response.json();
  }

  // ✅ Get permission by database ID
  async getById(id) {
    const response = await fetch(`${this.baseUrl}/id/${id}`, {
      headers: this.getAuthHeaders()
    });
    return response.json();
  }

  // ✅ Get permission by patient ID
  async getByPatientId(patientId) {
    const response = await fetch(`${this.baseUrl}/patient/${patientId}`, {
      headers: this.getAuthHeaders()
    });
    return response.json();
  }

  // ✅ Update entire permission entry
  async update(id, updatedPermission) {
    const response = await fetch(`${this.baseUrl}/${id}`, {
      method: 'PUT',
      headers: this.getAuthHeaders(),
      body: JSON.stringify(updatedPermission)
    });
    return response.json();
  }

  // ✅ Update single boolean column
  async updateColumn(id, column, value) {
    const response = await fetch(`${this.baseUrl}/${id}/update-column?column=${column}&value=${value}`, {
      method: 'PUT',
      headers: this.getAuthHeaders()
    });
    return response.json();
  }

  // ✅ Delete by ID
  async delete(id) {
    const response = await fetch(`${this.baseUrl}/delete/${id}`, {
      method: 'DELETE',
      headers: this.getAuthHeaders()
    });
    if (!response.ok) {
      throw new Error('Failed to delete');
    }
  }
}

export default PatientContactPermissionService;
